import { render } from "./BottomView.vue?vue&type=template&id=68c34a62"
import script from "./BottomView.vue?vue&type=script&lang=js"
export * from "./BottomView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Desktop/cms/shop-mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__